import React from 'react';

const MicToggle = ({ isOpen, onClick, disabled = false }) => {
  return (
    <button
      className={`mic-toggle ${isOpen ? 'open' : 'closed'} ${disabled ? 'disabled' : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={isOpen ? 'Arrêter l\'enregistrement' : 'Démarrer l\'enregistrement'}
    >
      {isOpen ? (
        // Recording → Carré stop (Voice Memos style)
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor"/>
        </svg>
      ) : (
        // Idle → Cercle avec point au centre (Voice Memos style)
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
          <circle cx="12" cy="12" r="4" fill="currentColor"/>
        </svg>
      )}
    </button>
  );
};

export default MicToggle;